<template>
  <div class="advertising_vip">
    <!-- 广告管理 -->
    <div class="bodycontent">
      <!-- 头部菜单 -->
      <div class="option">
        <div class="left">
          <el-button type="primary" icon="el-icon-setting" @click="showSet=true">添加广告</el-button>
        </div>
        <div class="right">
          <span>
            <el-input
              type="text"
              placeholder="文章标题"
              v-model="keyword"
              style="width:180px"
              clearable
            />
          </span>
          <span>
            <el-button type="primary" @click="search()">搜索</el-button>
          </span>
        </div>
      </div>
      <!-- 开卡记录列表 -->
      <el-table :data="listData">
        <el-table-column label="标题" prop="ordersn"></el-table-column>
        <el-table-column label="创建时间" prop="name"></el-table-column>
        <el-table-column label="图片" prop="mobile">15020935375</el-table-column>
        <el-table-column label="小程序连接">普通会员</el-table-column>
        <el-table-column label="公众号链接">普通会员</el-table-column>
        <el-table-column label="位置" prop="mobile">15020935375</el-table-column>
        <el-table-column label="状态">普通会员</el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="120px">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="delItem(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog :visible.sync="showSet" @close="showSet=false" title="发布文章" width="70%">
        <div>
          <el-row>
            <el-col :span="4">
              <div class="grid-content bg-purple">标题：</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-input v-model="headline" placeholder="请输入内容"></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <div class="grid-content bg-purple">图片:</div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">小程序连接：</div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple-light">
              <el-input v-model="smallRoutine" placeholder="请输入内容" style="width:80%"></el-input>
              <el-button type="primary">选择</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">公众号链接：</div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple-light">
              <el-input v-model="smallRoutine" placeholder="请输入内容" style="width:80%"></el-input>
              <el-button type="primary">选择</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">状态：</div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple-light">
              <template>
                <el-radio v-model="radio" label="1">开启</el-radio>
                <el-radio v-model="radio" label="2">关闭</el-radio>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">位置：</div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple-light">
              <template>
                <el-radio v-model="radio" label="1">顶部</el-radio>
                <el-radio v-model="radio" label="2">底部</el-radio>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple"></div>
          </el-col>
          <el-col :span="20">
            <div class="grid-content bg-purple">
              <el-button @click="showSet = false">取消</el-button>
              <el-button type="primary" @click="showSet = false">确定</el-button>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getOpenSet, setOpenSet } from "@/api/vip";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "",
      smallRoutine: "", // 小程序链接
      textarea2: "", //主要内容
      imageUrl: "",
      headline: "",
      is_show: "", //类型筛选
      listData: [], //列表
      keyword: "", //关键字筛选
      page: 1,
      total: 0,
      showSet: false
    };
  },
  methods: {
    handleRemove(file, fileList) {
        console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    search() {},
    //跳页
    handleCurrentChange(p) {},

    //删除
    delItem(i) {}
  }
};
</script>
<style lang="scss" scoped>
.advertising_vip {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .grid-content {
    min-height: 36px;
    margin-top: 15px;
    font-size: 16px;
    .width100 {
      width: 100%;
    }
  }
  .bg-purple {
    text-align: right;
  }
  .bodycontent {
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .option {
      height: 79px;
      line-height: 79px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .level_img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
  }
}
</style>

<style lang="scss">
.advertising_vip {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
